export default [
  {
    path: '',
    component: () => {
      if (window.gd_customize.indexOf(window.location.host) > -1) {
        return import('@/pages/home/customize/GDJobs');
      }
      return import('@/pages/home/Index');
    },
    name: 'home'
  },
  {
    path: 'submit-resume',
    component: () => import('@/pages/home/ResumeWelcomeScreen'),
    name: 'home.submit-resume'
  },
];
